import React from 'react';
import Table from '../../component/table/table'
import { BASE_END_POINT } from '../../urls'
import axios from 'axios'
import Button from '@material-ui/core/Button';
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader } from "mdbreact";
import './request.css'
import { message, TreeSelect, DatePicker, ConfigProvider } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom'
import { ChangeLanguage } from '../../redux/actions/LanguageAction'
import { CSVLink } from "react-csv";
import PaginationButtons from '../../component/pagenation/pagenation';
import moment from 'moment'
import locale_ar from 'antd/lib/locale/ar_EG';
import locale_en from 'antd/lib/locale/en_GB';
import 'moment/locale/ar';
const { TreeNode } = TreeSelect;
const { SHOW_PARENT } = TreeSelect;
const { RangePicker } = DatePicker;
let headers = [
  { label: "#", key: "id" },
  { label: "نوع العميل", key: "clientType" },
  { label: "العميل", key: "client" },
  { label: "رقم الهاتف", key: "phone" },
  { label: "المدينه", key: "city" },
  { label: "الحى", key: "area" },
  { label: "النوع الرئيسى", key: "category" },
  { label: "النوع الفرعى", key: "subCategory" },
  { label: "القدره الشرائيه", key: "price" },
  { label: "الحاله", key: "status" },
];

let csvData = [

];
class request extends React.Component {

  state = {
    requests: [],
    requests2: [],
    loading: true,
    refresh: false,
    page: 1,
    pages: 1,
    search: this.props.location.state ? this.props.location.state.requestsSearchData ? this.props.location.state.requestsSearchData.search ? this.props.location.state.requestsSearchData.search : null : null : null,
    countries: [],
    count: 0,
    cities: [],
    areas: [],
    categories: [],
    subCategories: [],
    area: this.props.location.state ? this.props.location.state.requestsSearchData ? this.props.location.state.requestsSearchData.area ? this.props.location.state.requestsSearchData.area : null : null : null,
    city: this.props.location.state ? this.props.location.state.requestsSearchData ? this.props.location.state.requestsSearchData.city ? this.props.location.state.requestsSearchData.city : null : null : null,
    country: this.props.location.state ? this.props.location.state.requestsSearchData ? this.props.location.state.requestsSearchData.country ? this.props.location.state.requestsSearchData.country : null : null : null,
    category: this.props.location.state ? this.props.location.state.requestsSearchData ? this.props.location.state.requestsSearchData.category ? this.props.location.state.requestsSearchData.category : null : null : null,
    subCategory: this.props.location.state ? this.props.location.state.requestsSearchData ? this.props.location.state.requestsSearchData.subCategory ? this.props.location.state.requestsSearchData.subCategory : null : null : null,
    status: this.props.location.state ? this.props.location.state.requestsSearchData ? this.props.location.state.requestsSearchData.status ? this.props.location.state.requestsSearchData.status : null : null : null,
    showFilter: false,
    startDate: this.props.location.state ? this.props.location.state.requestsSearchData ? this.props.location.state.requestsSearchData.startDate ? this.props.location.state.requestsSearchData.startDate : null : null : null,
    endDate: this.props.location.state ? this.props.location.state.requestsSearchData ? this.props.location.state.requestsSearchData.endDate ? this.props.location.state.requestsSearchData.endDate : null : null : null,
    hasSuggestedAdvertisements: this.props.location.state ? this.props.location.state.requestsSearchData ? this.props.location.state.requestsSearchData.hasSuggestedAdvertisements ? this.props.location.state.requestsSearchData.hasSuggestedAdvertisements : null : null : null,

    csvData: [],
    isReady: false,
    buildCsv: false,
    users: [],
    user: null,
    assignedToId: null,
    assignedTo: this.props.location.state ? this.props.location.state.data ? this.props.location.state.data.assignedTo : null : null,
    modalForAssigned: false,
    selectedRow: null,
    priceFrom: this.props.location.state ? this.props.location.state.requestsSearchData ? this.props.location.state.requestsSearchData.priceFrom ? this.props.location.state.requestsSearchData.priceFrom : null : null : null,
    priceTo: this.props.location.state ? this.props.location.state.requestsSearchData ? this.props.location.state.requestsSearchData.priceTo ? this.props.location.state.requestsSearchData.priceTo : null : null : null,
    project: this.props.location.state ? this.props.location.state.requestsSearchData ? this.props.location.state.requestsSearchData.project ? this.props.location.state.requestsSearchData.project : null : null : null,
    projects: []
  }

  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }

  componentDidMount() {
    let pageNum = this.state.page
    if (sessionStorage.getItem('pageName') === "REQUESTS") {
      pageNum = sessionStorage.getItem('pageNum');
      this.setState({ page: pageNum })
    }

    this.getRequests(pageNum, false)
    this.getUserWithoutPagenation()
    this.getCategory()
    this.getProjects()
    this.getCountries()
    if (this.state.country) {
      this.getCities(this.state.country)
    }
    if (this.state.city) {
      this.getAreas(this.state.city)
    }
    if (this.state.category) {
      this.getSubCategory(this.state.category)
    }
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  getProjects = () => {
    axios.get(`${BASE_END_POINT}projects/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ projects: response.data.data })
      })
      .catch(error => {
        console.log("ALL projects ERROR")
        console.log(error.response)
      })
  }
  getUserWithoutPagenation = () => {
    axios.get(`${BASE_END_POINT}quickSearch/get?type=SUB-ADMIN`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      },
    }).then(response => {
      console.log(response.data.data)
      this.setState({ users: response.data.data })
    })
      .catch(error => {
        console.log("ALL users ERROR")
        console.log(error.response)
      })
  }
  deleteRequest = (id) => {
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}requests/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
    })
      .then(response => {
        console.log("request DELETED")
        l.then(() => message.success(allStrings.done, 2.5))
        this.getRequests(this.state.page)
      })
      .catch(error => {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }
  getCountries = () => {
    axios.get(`${BASE_END_POINT}countries/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ countries: response.data.data })
      })
      .catch(error => {
        console.log("ALL countries ERROR")
        console.log(error.response)
      })
  }
  getAreas = (city) => {
    axios.get(`${BASE_END_POINT}areas/${city}/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ areas: response.data.data })
      })
      .catch(error => {
        console.log("ALL areas ERROR")
        console.log(error.response)
      })
  }
  getCities = (country) => {
    axios.get(`${BASE_END_POINT}countries/${country}/cities/withoutPagenation/get?country=${country}`)
      .then(response => {
        console.log(response.data)
        this.setState({ cities: response.data.data })
      })
      .catch(error => {
        console.log("ALL cities ERROR")
        console.log(error.response)
      })
  }
  getCategory = () => {
    axios.get(`${BASE_END_POINT}categories`)
      .then(response => {
        console.log(response.data)
        this.setState({ categories: response.data.data })
      })
      .catch(error => {
        console.log("ALL categories ERROR")
        console.log(error.response)
      })
  }
  getSubCategory = (category) => {
    axios.get(`${BASE_END_POINT}categories/${category}/sub-categories`)
      .then(response => {
        console.log(response.data)
        this.setState({ subCategories: response.data.data })
      })
      .catch(error => {
        console.log("ALL subCategories ERROR")
        console.log(error.response)
      })
  }
  getRequests = (page, refresh) => {
    this.setState({ loading: true })
    let { hasSuggestedAdvertisements, project, priceFrom, priceTo, user, city, area, country, category, subCategory, status, search, startDate, endDate } = this.state
    let url = `${BASE_END_POINT}requests?page=${page}&all=true`
    if (refresh !== true) {
      let keysToFilter = { hasSuggestedAdvertisements, project, priceFrom, priceTo, user, city, area, country, category, subCategory, status, search, startDate, endDate }
      Object.keys(keysToFilter).forEach(key => {
        if (keysToFilter[key] !== null) {
          url += `&${key}=${keysToFilter[key]}`;
        }
      });
      //search data 
      let requestsSearchData = Object.fromEntries(
        Object.entries({
          hasSuggestedAdvertisements, project, priceFrom, priceTo, user, city, area, country, category, subCategory, status, search, startDate, endDate
        }).filter(([_, value]) => value !== "" && value != null)
      );
      sessionStorage.setItem('requestsSearchData', JSON.stringify(requestsSearchData));
    } else {
      this.setState({ hasSuggestedAdvertisements: null, project: null, priceFrom: null, priceTo: null, user: null, city: null, area: null, country: null, category: null, subCategory: null, status: null, search: null, startDate: null, endDate: null })
      sessionStorage.setItem('requestsSearchData', JSON.stringify({}));
    }

    axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      },
    })
      .then(response => {
        console.log("request   ", response.data)
        let data = response.data.data.map((item, index) => {
          return [
            item.id,
            item.user ? item.user.fullname.substr(0, 15) : "",
            item.fullname ? item.fullname : "",
            item.assignedTo ? item.assignedTo.fullname : 'لايوجد',
            item.hasSuggestedAdvertisements ? { type: 'tag', value: allStrings.yes } : { type: 'tag', value: allStrings.no },
            item.city ? item.city.cityName : "",
            item.subCategory ? item.subCategory.categoryName : "",
            item.status === "NEW" ? { type: 'tag', value: allStrings.new } : item.status === "ON-PROGRESS" ? { type: 'tag', value: allStrings.onProgress } : item.status === "COMPLETED" ? { type: 'tag', value: allStrings.completed } : { type: 'tag', value: allStrings.failed },
            item.createdAt ? this.props.isRTL ? moment(item.createdAt).locale('ar').format('ll') : moment(item.createdAt).locale('en').format('ll') : "",
            "action"
          ]
        })
        this.setState({
          loading: false,
          refresh: false,
          requests: response.data.data,
          requests2: data,
          page: response.data.page,
          count: response.data.totalCount,
          pages: response.data.pageCount,
        })
        sessionStorage.setItem('pageNum', page);
        sessionStorage.setItem('pageName', "REQUESTS");
      })
      .catch(error => {
        console.log("error   ", error.response)
        console.log("error2   ", error)
        this.setState({ loading: false, })
      })
  }
  getRequestsWithoutPagenation = (refresh) => {
    let { hasSuggestedAdvertisements, project, priceFrom, priceTo, user, city, area, country, category, subCategory, status, search, startDate, endDate } = this.state
    let url = `${BASE_END_POINT}requests/withoutPagenation/get?all=true`
    if (refresh !== true) {
      let keysToFilter = { hasSuggestedAdvertisements, project, priceFrom, priceTo, user, city, area, country, category, subCategory, status, search, startDate, endDate }
      Object.keys(keysToFilter).forEach(key => {
        if (keysToFilter[key] !== null) {
          url += `&${key}=${keysToFilter[key]}`;
        }
      });
      //search data 
      let requestsSearchData = Object.fromEntries(
        Object.entries({
          hasSuggestedAdvertisements, project, priceFrom, priceTo, user, city, area, country, category, subCategory, status, search, startDate, endDate
        }).filter(([_, value]) => value !== "" && value != null)
      );
      sessionStorage.setItem('requestsSearchData', JSON.stringify(requestsSearchData));
    } else {
      this.setState({ hasSuggestedAdvertisements: null, project: null, priceFrom: null, priceTo: null, user: null, city: null, area: null, country: null, category: null, subCategory: null, status: null, search: null, startDate: null, endDate: null })
      sessionStorage.setItem('requestsSearchData', JSON.stringify({}));
    }
    axios.get(url, {
      headers: {
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      }
    })
      .then(response => {

        csvData = response.data.data.map(item => {
          return {
            ...{ id: item.id },
            ...{ clientType: item.clientType ? item.clientType === "RENT" ? allStrings.rent : item.clientType === "INVESTMENT" ? allStrings.investment : item.clientType === "OFF-PLAN-SALE" ? allStrings.offPlanSale : allStrings.housing : '' },
            ...{ client: item.fullname ? item.fullname : '' },
            ...{ phone: item.phone ? "\t" + item.phone : '' },
            ...{ city: item.city.cityName ? item.city.cityName : '' },
            ...{ area: item.area.areaName ? item.area.areaName : '' },
            ...{ category: item.category.categoryName ? item.category.categoryName : '' },
            ...{ subCategory: item.subCategory.categoryName ? item.subCategory.categoryName : '' },
            ...{ price: item.priceFrom ? ` من ${item.priceFrom} الى ${item.priceTo} ` : '' },
            ...{ status: item.status == "NEW" ? allStrings.new : this.state.status == "ON-PROGRESS" ? allStrings.onProgress : item.status == "COMPLETED" ? allStrings.completed : allStrings.failed },
          };
        });
        this.setState({ csvData: csvData, isReady: true })


      })
      .catch(error => {
        console.log("error   ", error.response)
        console.log("error2   ", error)
      })
  }

  assignedTo = () => {
    const { assignedToId } = this.state
    const idsArray = this.state.selectedRow.map(item => item.id);
    console.log("idsArray", idsArray)
    if (assignedToId != null) {
      let l = message.loading('Wait..', 2.5)
      axios.put(`${BASE_END_POINT}requests/${idsArray}/assignTo/${assignedToId}`, {
        ids: idsArray
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.props.currentUser.token}`,
          'Accept-Language': this.props.isRTL ? 'ar' : 'en',
        },
      })
        .then(response => {
          console.log("interest assigned To")
          l.then(() => message.success(allStrings.done, 2.5))
          this.getRequests(this.state.page, false)
          this.setState({ modalForAssigned: false, assignedToId: null, selectedRow: null })
        })
        .catch(error => {
          console.log(error.response)
          l.then(() => message.error(allStrings.error, 2.5))
        })
    }
  }
  submitHandlerAssigned = (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.assignedTo()
  };
  toggleForAssigned = (rowData) => {
    console.log("rowData", rowData)
    this.setState({
      selectedRow: Array.isArray(rowData) ? rowData : [rowData],
      modalForAssigned: !this.state.modalForAssigned,
    });
  };
  modalForAssigned = () => (
    <MDBModal isOpen={this.state.modalForAssigned} toggle={this.toggleForAssigned} size="lg">
      <MDBModalHeader toggle={this.toggleForAssigned} >{allStrings.completeData}</MDBModalHeader>
      <MDBModalBody>
        <MDBContainer>
          <MDBRow>
            <MDBCol md="12">
              <form style={{ paddingTop: '1rem' }}
                className="needs-validation"
                onSubmit={this.submitHandlerAssigned}
                noValidate
              >
                <div className="grey-text">
                  {this.state.selectedRow && this.state.selectedRow.length > 0 ? (
                    <div>
                      <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>
                        {this.state.selectedRow.map(row => `#${row ? row.id : ""}`).join(' - ')}
                      </label>
                    </div>
                  ) : null}

                  <MDBRow>
                    <MDBCol md="12">
                      <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.employee}</label>
                      <TreeSelect virtual={false}
                        showSearch={true}
                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                        treeCheckable={false}
                        treeNodeFilterProp="title"
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        placeholder={allStrings.employee}
                        onChange={(value) => {
                          console.log(value)
                          this.setState({ assignedToId: value });
                        }}

                      >
                        {this.state.users.map(val => (
                          <TreeNode value={val.id} title={val.fullname} key={val.id} />
                        ))}
                      </TreeSelect>
                    </MDBCol>
                  </MDBRow>
                </div>
                <div className="drawer-action-footer">
                  <MDBBtn type="button" className="btn-cancel" onClick={this.toggleForAssigned}>
                    إلغاء
                  </MDBBtn>
                  <MDBBtn type="submit" className="btn-submit">
                    {allStrings.send}
                  </MDBBtn>
                </div>
              </form>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </MDBModalBody>
    </MDBModal>
  );
  onChange = (date, dateString) => {
    if (this.props.isRTL) {
      this.setState({
        startDate: moment(dateString[0]).locale('en').format("YYYY-MM-DD"),
        endDate: moment(dateString[1]).locale('en').format("YYYY-MM-DD")
      })
    } else {
      this.setState({ to: moment(dateString).locale('en').format("YYYY/MM/DD") })
      this.setState({
        startDate: moment(dateString[0]).locale('en').format("YYYY-MM-DD"),
        endDate: moment(dateString[1]).locale('en').format("YYYY-MM-DD")
      })
      console.log(moment(dateString[0]).locale('en').format("YYYY-MM-DD"))

    }
    console.log(dateString);
  }

  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('REQUESTS')) return <Redirect to='/Home' />

    return (
      <div className="App">

        <MDBContainer>
          <MDBRow>
            {this.modalForAssigned()}
            <MDBCol md="12">
              <div className="screenTable">
                <Table
                  settings={
                    <div>
                      <i class="fab fa-searchengin searchIcon" onClick={() => this.setState({ showFilter: !this.state.showFilter })}></i>
                      <span
                        style={{ zIndex: '1', position: 'relative', padding: '4px', color: '#659FF1', fontSize: '25px', borderRadius: '50%', top: '4px', cursor: 'pointer' }}
                        onClick={() => { this.getRequests(1, true); this.setState({ buildCsv: false }) }}
                        class="material-icons">
                        replay
                      </span>
                      {!this.state.buildCsv &&
                        <img crossorigin="anonymous" alt="" onClick={() => { this.setState({ buildCsv: true }); this.getRequestsWithoutPagenation() }}
                          style={{ padding: '0px', position: 'relative', top: '-6px', marginLeft: '5px', cursor: 'pointer' }}
                          src={require('../../assets/images/buildCsv.png')} width="26"></img>
                      }{!this.state.isReady && this.state.buildCsv &&
                        <img crossorigin="anonymous" alt=""
                          style={{ padding: '0px', position: 'relative', top: '-5px', marginLeft: '-15px' }}
                          src={require('../../assets/images/loading.gif')} width="70"></img>
                      }{this.state.isReady && this.state.buildCsv &&
                        <CSVLink
                          data={this.state.csvData}
                          headers={headers}
                          filename={"requests.csv"}
                          style={{ padding: '10px', position: 'relative', top: '-5px' }}
                        >
                          <img alt="" src={require('../../assets/images/export-csv.png')} width="28"></img>
                        </CSVLink>
                      }
                    </div>
                  }
                  filter={
                    <div>
                      <div className={this.state.showFilter ? 'showClass' : 'hideClass'}>
                        <MDBRow>
                          <MDBCol xl="4" lg="4" md="4" sm="12">
                            <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.area}</label>
                            <TreeSelect virtual={false}
                              showSearch={true}
                              style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                              treeCheckable={false}
                              treeNodeFilterProp="title"
                              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                              placeholder={allStrings.area}
                              value={this.state.area}
                              showCheckedStrategy={SHOW_PARENT}
                              onChange={(value) => {
                                console.log(value)
                                this.setState({ area: value });

                              }}

                            >
                              {this.state.areas.map(val => (
                                <TreeNode value={val.id} title={this.props.isRTL ? val.areaName_ar : val.areaName_en} key={val.id} />
                              ))}
                            </TreeSelect>
                          </MDBCol>
                          <MDBCol xl="4" lg="4" md="4" sm="12">
                            <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.city}</label>
                            <TreeSelect virtual={false}
                              showSearch={true}
                              style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                              treeCheckable={false}
                              treeNodeFilterProp="title"
                              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                              placeholder={allStrings.city}
                              value={this.state.city}
                              showCheckedStrategy={SHOW_PARENT}
                              onChange={(value) => {
                                console.log(value)
                                this.setState({ city: value });
                                this.getAreas(value)
                              }}

                            >
                              {this.state.cities.map(val => (
                                <TreeNode value={val.id} title={this.props.isRTL ? val.cityName_ar : val.cityName_en} key={val.id} />
                              ))}
                            </TreeSelect>
                          </MDBCol>
                          <MDBCol xl="4" lg="4" md="4" sm="12">
                            <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.country}</label>
                            <TreeSelect virtual={false}
                              showSearch={true}
                              style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                              treeCheckable={false}
                              treeNodeFilterProp="title"
                              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                              placeholder={allStrings.country}
                              value={this.state.country}
                              showCheckedStrategy={SHOW_PARENT}
                              onChange={(value) => {
                                console.log(value)
                                this.setState({ country: value });
                                this.getCities(value)
                              }}

                            >
                              {this.state.countries.map(val => (
                                <TreeNode value={val.id} title={this.props.isRTL ? val.countryName_ar : val.countryName_en} key={val.id} />
                              ))}
                            </TreeSelect>
                          </MDBCol>
                        </MDBRow>
                        <MDBRow>
                          <MDBCol xl="4" lg="4" md="4" sm="12">
                            <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.subCategory}</label>
                            <TreeSelect virtual={false}
                              showSearch={true}
                              style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                              treeCheckable={false}
                              treeNodeFilterProp="title"
                              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                              placeholder={allStrings.subCategory}
                              value={this.state.subCategory}
                              showCheckedStrategy={SHOW_PARENT}
                              onChange={(value) => {
                                console.log(value)
                                this.setState({ subCategory: value });
                              }}

                            >
                              {this.state.subCategories.map(val => (
                                <TreeNode value={val.id} title={this.props.isRTL ? val.categoryName_ar : val.categoryName_en} key={val.id} />
                              ))}
                            </TreeSelect>
                          </MDBCol>
                          <MDBCol xl="4" lg="4" md="4" sm="12">
                            <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.category}</label>
                            <TreeSelect virtual={false}
                              showSearch={true}
                              style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                              treeCheckable={false}
                              treeNodeFilterProp="title"
                              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                              placeholder={allStrings.category}
                              value={this.state.category}
                              showCheckedStrategy={SHOW_PARENT}
                              onChange={(value) => {
                                console.log(value)
                                this.setState({ category: value });
                                this.getSubCategory(value)
                              }}

                            >
                              {this.state.categories.map(val => (
                                <TreeNode value={val.id} title={this.props.isRTL ? val.categoryName_ar : val.categoryName_en} key={val.id} />
                              ))}
                            </TreeSelect>
                          </MDBCol>
                          <MDBCol xl="4" lg="4" md="4" sm="12">
                            <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.status}</label>
                            <TreeSelect virtual={false}
                              showSearch={true}
                              value={this.state.status}
                              style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                              treeCheckable={false}
                              treeNodeFilterProp="title"
                              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                              placeholder={allStrings.status}
                              onChange={(value) => {
                                console.log(value)
                                this.setState({ status: value });
                              }}

                            >
                              <TreeNode value="PENDING" title={allStrings.new} key="PENDING" />
                              <TreeNode value="CONTACT-PHASE" title={allStrings.contactPhase} key="CONTACT-PHASE" />
                              <TreeNode value="COMPLETED" title={allStrings.completed} key="COMPLETED" />
                              <TreeNode value="FAILED" title={allStrings.failed} key="FAILED" />

                            </TreeSelect>
                          </MDBCol>
                        </MDBRow>
                        <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                          <MDBCol xl="4" lg="4" md="4" sm="12">
                            <div className="md-form">
                              <label htmlFor="form920" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.priceFrom}</label>
                              <input name="priceFrom" placeholder={allStrings.price} onChange={(e) => { this.setState({ priceFrom: e.target.value }) }} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="number" min={0} id="form920" className="form-control" />
                              <div class="invalid-feedback">{allStrings.requiredInput}</div>
                            </div>
                          </MDBCol>
                          <MDBCol xl="4" lg="4" md="4" sm="12">
                            <div className="md-form">
                              <label htmlFor="form920" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.priceTo}</label>
                              <input name="priceTo" placeholder={allStrings.price} onChange={(e) => { this.setState({ priceTo: e.target.value }) }} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="number" min={0} id="form920" className="form-control" />
                            </div>
                          </MDBCol>
                          <MDBCol xl="4" lg="4" md="4" sm="12">
                            <label htmlFor="form605" className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.date}</label>
                            <ConfigProvider locale={this.props.isRTL ? locale_ar : locale_en}>
                              <RangePicker value={[
                                this.state.startDate ? moment(this.state.startDate, "YYYY-MM-DD") : null,
                                this.state.endDate ? moment(this.state.endDate, "YYYY-MM-DD") : null
                              ]} format={"YYYY-MM-DD"} placeholder={[allStrings.startDate, allStrings.endDate]} onChange={this.onChange} />
                            </ConfigProvider>
                          </MDBCol>
                        </MDBRow>
                        <MDBRow>
                          <MDBCol xl="4" lg="4" md="4" sm="12">
                            <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.hasSuggestedAdvertisements}</label>
                            <TreeSelect virtual={false}
                              showSearch={true}
                              value={this.state.hasSuggestedAdvertisements}
                              style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                              treeCheckable={false}
                              treeNodeFilterProp="title"
                              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                              placeholder={allStrings.hasSuggestedAdvertisements}
                              onChange={(value) => {
                                console.log(value)
                                this.setState({ hasSuggestedAdvertisements: value });
                              }}

                            >
                              <TreeNode value={true} title={allStrings.yes} key={true} />
                              <TreeNode value={false} title={allStrings.no} key={false} />
                            </TreeSelect>
                          </MDBCol>
                          <MDBCol xl="4" lg="4" md="4" sm="12">
                            <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.project}</label>
                            <TreeSelect virtual={false}
                              showSearch={true}
                              style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                              treeCheckable={false}
                              treeNodeFilterProp="title"
                              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                              placeholder={allStrings.project}
                              value={this.state.project}
                              onChange={(value) => {
                                console.log(value)
                                this.setState({ project: value });

                              }}
                            >
                              {this.state.projects.map(val => (
                                <TreeNode value={val.id} title={this.props.isRTL ? val.name_ar : val.name_en} key={val.id} />
                              ))}
                            </TreeSelect>
                          </MDBCol>
                          <MDBCol xl="4" lg="4" md="4" sm="12">
                            <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.employee}</label>
                            <TreeSelect virtual={false}
                              showSearch={true}
                              style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                              treeCheckable={false}
                              treeNodeFilterProp="title"
                              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                              placeholder={allStrings.employee}
                              onChange={(value) => {
                                console.log(value)
                                this.setState({ user: value });
                              }}

                            >
                              {this.state.users.map(val => (
                                <TreeNode value={val.id} title={val.fullname} key={val.id} />
                              ))}
                            </TreeSelect>
                          </MDBCol>

                        </MDBRow>
                        <MDBRow>
                          <MDBCol xl="12" lg="12" md="12" sm="12">
                            <div class="md-form">
                              <label htmlFor="form605" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.Search}</label>
                              <input style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', fontWeight: '300' }} type="text" id="form605" class="form-control"
                                placeholder={allStrings.adsFilterSearch}
                                onChange={(e) => {
                                  this.setState({ search: e.target.value })
                                }} />
                            </div>
                          </MDBCol>
                        </MDBRow>
                        <Button style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff', width: '100%', margin: '32px auto' }}
                          onClick={() => { this.getRequests(1); this.setState({ buildCsv: false }) }}><SearchOutlined /> {allStrings.Search}</Button>

                      </div>
                    </div>
                  }
                  title={allStrings.requests}
                  enableEdit={false}
                  icon='featured_video'
                  data={this.state.requests}
                  data2={this.state.requests2}
                  tableColumns={["#", allStrings.owner, allStrings.client, allStrings.employee, allStrings.hasSuggestedAdvertisements, allStrings.city, allStrings.type, allStrings.status, allStrings.createdAt, allStrings.action]}
                  loading={this.state.loading}
                  deleteItem={(id) => { this.deleteRequest(id) }}
                  path='/requestInfo'
                  dataCount={this.state.count}
                  actionIndex={5}
                  enableAssigne={this.props.currentUser.user.type === "ADMIN" ? true : this.props.currentUser.user.isEmployee == false ? true : false}
                  assignedToModal={(rowData) => this.toggleForAssigned(rowData)}
                  noDelete={true}
                />
                <PaginationButtons
                  page={this.state.page}
                  pages={this.state.pages}
                  labels={allStrings}
                  onPageChange={(newPage) => {
                    this.getRequests(newPage);
                    this.setState({ page: newPage });
                  }}
                />

              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    )
  }
}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDispatchToProps = {
  ChangeLanguage
}

export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(request)
);

